// extracted by mini-css-extract-plugin
export default {"contentCenter":"styles_contentCenter__5P3Mu","wrapper":"styles_wrapper__lKoM7"};